import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { normalizeIds } from '@/utils/ids';

import { TClientSimpleEntity } from '../types';

import { clientQueryKeys } from './query-keys';

export async function getClientsByIds(ids: string[]): Promise<TClientSimpleEntity[]> {
  return acceso360Client
    .get('/monitoring/api/v1/clients/by_ids', { params: { ids: ids.join(',') } })
    .then(({ data }) => data);
}

type QueryFnType = typeof getClientsByIds;

interface UseClientsByIdsParams {
  ids: string[];
  config?: Omit<QueryConfig<QueryFnType>, 'enabled'>;
}

export function useClientsByIds({ ids, config = {} }: UseClientsByIdsParams) {
  const uniqueIds = normalizeIds(ids);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: clientQueryKeys.clientsByIds(uniqueIds),
    queryFn() {
      return getClientsByIds(uniqueIds);
    },
    enabled: uniqueIds.length > 0,
  });
}
